var map = {
	"./401.gif": "66db",
	"./404.png": "3fce",
	"./404_cloud.png": "7e19",
	"./ai_icon_logo.png": "953c",
	"./assistant_bg.png": "7fbe",
	"./avatar-agent.png": "3faa",
	"./avatar-user-saas.png": "3914",
	"./avatar-user.png": "d731",
	"./back.png": "4c1d",
	"./banner_platform.png": "2f6b",
	"./banner_tripartite.png": "e89e",
	"./bg_empty.png": "6f66",
	"./bottom_file.png": "2b54",
	"./bottom_order.png": "5021",
	"./bottom_photo.png": "0db0",
	"./bottom_store.png": "79de",
	"./chat-logo.png": "3c45",
	"./chat_ai_bg.png": "c624",
	"./chat_background.png": "7e88",
	"./chat_head.png": "ff57",
	"./chat_head_close.png": "f8f8",
	"./chat_list_icon.png": "ff74",
	"./chat_send.png": "5d49",
	"./checked_star.png": "e145",
	"./checked_star_pc.png": "b093",
	"./close.png": "0c23",
	"./custom-emoji.png": "944b",
	"./custom-upload-file.png": "5f87b",
	"./custom-upload-image.png": "8206",
	"./default_product_image.jpg": "ff38",
	"./dislike.png": "cb95",
	"./dislike_checked.png": "b69d",
	"./emotion.png": "2156",
	"./empty_order.png": "8281",
	"./estimation_m_1.png": "86ef",
	"./estimation_m_1_active.png": "5300",
	"./estimation_m_2.png": "3e23",
	"./estimation_m_2_active.png": "01a7",
	"./estimation_m_3.png": "b160",
	"./estimation_m_3_active.png": "05c3",
	"./estimation_m_4.png": "ffd7",
	"./estimation_m_4_active.png": "8e78",
	"./estimation_m_5.png": "ca64",
	"./estimation_m_5_active.png": "1efa",
	"./farenwei.png": "26bf",
	"./float-layer-ai_new.png": "4e5b",
	"./float-layer-heard.png": "1c6c",
	"./grouphead.png": "085f",
	"./grouphead1.png": "6584",
	"./guide_icon.png": "71ef",
	"./headservice.png": "eac2",
	"./icon-close.png": "9d38",
	"./icon-order-title.png": "16f3",
	"./icon-pc-close.png": "b2c6",
	"./icon_audit_progress.png": "e9c1",
	"./icon_company_certificate.png": "72a6",
	"./icon_contact_service.png": "d0f9",
	"./icon_info_collection_bg.png": "22b6",
	"./icon_info_collection_star.png": "d053",
	"./icon_my_order.png": "7ad8",
	"./icon_resolved.png": "1bc7",
	"./icon_resolved_orange.png": "95d3",
	"./icon_self_service_more.png": "6408",
	"./icon_unknown-format.png": "67d6",
	"./icon_unsolved.png": "8857",
	"./icon_unsolved_orange.png": "366c",
	"./icons.png": "7eb5",
	"./im_chat_bg.png": "1b0b",
	"./like.png": "6ebd",
	"./like_checked.png": "fa79",
	"./loading.gif": "f1c7",
	"./message_badge.png": "f1c9",
	"./message_badge_gray.png": "1eec",
	"./message_badge_qa.png": "53d9",
	"./message_badge_qa_blue.png": "ff743",
	"./message_badge_white.png": "bf85",
	"./more_icon.png": "4573",
	"./myorder.png": "2497",
	"./no_session_empty.png": "1042",
	"./photo_crm.png": "6495",
	"./pic_icon.png": "dd41",
	"./right_back.png": "a1d8",
	"./right_message_gray.png": "c05d",
	"./search_icon.png": "5169",
	"./send_btn.png": "2222",
	"./send_btn_blue.png": "eecb",
	"./send_disabled.png": "2d88",
	"./shenhejindu.png": "7a82",
	"./stop.png": "d477",
	"./submit_success.png": "dae3",
	"./survey_banner_app.png": "1847",
	"./survey_banner_pc.png": "97d4",
	"./title_search.png": "f188",
	"./tripartite.png": "5039",
	"./unchecked_star.png": "d5a5",
	"./unchecked_star_pc.png": "861a",
	"./welcome_head_icon.png": "e883"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";